export const GET_ALL_HOLIDAY: string = "GET_ALL_USER";
export const GET_ONE_HOLIDAY: string = "GET_ONE_USER";
export const LOADING: string = "LOADING";
